<script setup lang="ts">


import moment from "moment";
import { onMounted,onBeforeMount} from "vue";
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';

import CalcBuilding from './pages/CalcBuilding.vue';


onBeforeMount(()=>{
 console.log("before app")
})
onMounted(()=>{
  
  Date.prototype.toJSON = function () {
        return moment(this).format();
    }
    
  locale(sessionStorage.getItem('locale') || 'ru');

  loadMessages(ruMessages);
  
  
})
</script>

<template>
   <div id="store_page" style="font-family:  'EvrazSans'">
    <div class="container-fluid">
      <CalcBuilding/>
    </div>
  </div>

  
</template>

<style scoped>

</style>
